export interface AdditionalService {
  additionalServiceCode?: string;
  additionalServiceDesc?: string;
  additionalServiceId: number;
}
